import React, { useEffect, useState } from 'react';
import { Gem, Loader2 } from 'lucide-react';
import Button from './ui/Button';

const LoadingTokensModal = ({ isOpen, onClose }) => {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (!isOpen) return;

    setCountdown(5);

    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    const redirectTimeout = setTimeout(() => {
      onClose();
      window.location.href = '/tokens';
    }, 5000);

    return () => {
      clearTimeout(redirectTimeout);
      clearInterval(countdownInterval);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-zinc-900 p-8 text-center shadow-2xl">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-rose-500/15">
          <Loader2 className="h-8 w-8 animate-spin text-rose-400" />
        </div>
        <h2 className="mb-2 flex items-center justify-center gap-2 text-lg font-semibold text-white">
          <Gem className="h-5 w-5 text-rose-400" /> Carregando tokens
        </h2>
        <p className="mb-5 text-sm text-zinc-400">
          Redirecionando em <span className="font-semibold text-white">{countdown}s</span>
        </p>
        <Button
          onClick={() => {
            window.location.href = '/tokens';
          }}
          fullWidth
        >
          Ir para tokens agora
        </Button>
      </div>
    </div>
  );
};

export default LoadingTokensModal;
